module.exports = __webpack_public_path__ + "img/BF.e3679437.svg";